// extracted by mini-css-extract-plugin
module.exports = {"percentage-input":"percentage-input-24kH0s-"};